"use client";

import { useRouter } from "next/navigation";
import { useCallback } from "react";

export function useFastRouter() {
  const router = useRouter();

  const fastPush = useCallback(
    async (href: string) => {
      try {
        // Prefetch route assets first
        await router.prefetch(href);
      } catch (err) {
        console.warn("Prefetch failed:", err);
      }
      // Then navigate
      return router.push(href);
    },
    [router]
  );

  return { fastPush, router };
}
